<template>
  <div
    class="installment-box"
    :class="{ active, loading: loadingValues }"
    @click="(evt) => this.$emit('click', evt)"
  >
    <div class="installment-inner-content">
      <div class="installment-box-number">
        <h2>{{ installmentNumber }}</h2>
        <p class="small-bold">vezes</p>
      </div>
      <div class="installment-box-content">
        <div class="info-installment-value">
          <span class="body-bold primary">
            {{ installmentValue | moneyFilter }}
          </span> por mês
        </div>
        <div class="installment-box-info">
          <p class="info-total-interest">
            Juros {{ interest }}% a.m.
          </p>
          <p class="info-total-value">
            Total de {{ totalValue | moneyFilter }}
          </p>
        </div>
      </div>
    </div>

    <div :class="{active}" class="circle-check">
      <div v-if="active" class="inner-circle"/>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';

export default {
  name: 'down-payment-box-v2',
  mixins: [StringMixin],
  props: {
    installmentNumber: {
      type: Number,
      required: true,
    },
    installmentValue: {
      type: Number,
      required: true,
    },
    interest: {
      type: Number,
      required: true,
    },
    totalValue: {
      type: Number,
      required: true,
    },
    loadingValues: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .installment-skeleton {
    @extend .skeleton;
    height: 18px;
    color: transparent !important;

    span {
      color: transparent !important;
    }
  }

  .installment-box {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    width: 100%;

    background: var(--white);
    border: 1px solid var(--gray-200);
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      border: 1px solid var(--primary);
    }

    &.active {
      background-color: var(--primary-extra-light);
      border: 1px solid var(--primary);
    }

    &.loading {
      .info-installment-value {
        margin-bottom: 2px;
      }

      .info-installment-value, .info-total-interest {
        @extend .installment-skeleton;
        width: 80%;
      }

      .info-total-value {
        @extend .installment-skeleton;
        width: 40%;
      }
    }
  }

  .installment-inner-content {
    display: flex;
    gap: 16px;
  }

  .installment-box-number {
    background-color: var(--primary-dark);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--white);
    padding: 11px 15px;
  }

   .installment-box-content {
      width: 100%;
    }

  .installment-box-info {
    display: flex;
    flex-direction: column;
  }

  .info-total-interest {
    @extend .x-small-regular;
    @extend .gray-500;
    margin: 0;
  }

  .info-total-value {
    @extend .small-semibold;
    @extend .gray-700;
    margin-top: 8px;
  }

  .info-installment-value {
    @extend .small-regular;
    @extend .gray-500;
  }

  .circle-check {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    background-color: var(--gray-100);
    border-radius: 50%;
    border: 1px solid var(--gray-300);

    .inner-circle {
      background-color: var(--white);
      border-radius: 50%;
      width: 8px;
      height: 8px;
    }

    &.active {
      background-color: var(--primary);
      border: none;
    }
  }

/* .installment-option-box {
  display: flex;
  flex-direction: column;
  width: 31%;
  position: relative;

  .installment-option-inner-box {
    background: var(--white);
    border: 1px solid var(--gray-200);
    border-radius: 4px;
    padding: 12px;
    height: 93px;
    position: relative;

    span {
      @extend .body-bold;
      @extend .primary;
    }

    .installment-option-box-value {
      @extend .small-regular;
      @extend .gray-400;
      text-align: left;
      margin: 12px 0px 8px 0px;
    }

    .info-interest {
      @extend .x-small-regular;
      @extend .gray-400;
      text-align: left;
    }

    .info-total-value {
      @extend .x-small-semibold;
      @extend .gray-600;
      text-align: left;
      margin-top: 4px;
    }
  }

  &.loading {
    .installment-option-box-value, .info-interest {
      @extend .installment-skeleton;
      width: 80%;
    }

    .info-total-value {
      @extend .installment-skeleton;
      width: 40%;
    }
  }

  &.mobile {
    width: 100%;

    .installment-option-inner-box {
      display: grid;
      grid-template-columns: 3fr 1fr;
      grid-template-areas:
        'price installment'
        'info  installment';

      .installment-option-box-value {
        grid-area: price;
      }

      .installment-option-box-info {
        grid-area: info;
      }

      .installment-option-box-number {
        grid-area: installment;
        align-self: center;
      }
    }

    &.loading {
      .installment-option-box-number {
        color: transparent;
      }
    }
  }
}

.installment-option-box-number {
  @extend .small-semibold;
  @extend .white;

  float: right;
  margin-top: -10px;
  padding: 2px 10px;
  background: var(--primary-dark);
  height: 24px;
  width: 76px;
  border-radius: 12px;
  line-height: 24px;
} */

</style>
